import styled from "styled-components";

export const StyledAboutUs = styled.div``;
